import { useDispatch, useSelector } from "react-redux";
import { filterAppsForUser } from "../configs/AppsConfig";
import { toggleSider } from "../store/slices/appState.slice";
import { Layout } from "antd";
import Header from "./Header";
import Side from "./Side";
import { IAPlatformRoutes } from "../configs/AppRoutes";
import React from "react";

const { Content, Sider } = Layout;

const Frame = ({ keys }) => {
  const dispatch = useDispatch();
  const showSider = useSelector((state) => state.appStates.siderVisible); // Get sider visible state from Redux
  const widgets = filterAppsForUser(keys);

  const onToggleSider = () => {
    dispatch(toggleSider()); // Toggle collapse/expand
  };

  return (
    <Layout style={{ height: "100vh", overflow: "hidden" }}>
      <Header onToggleSider={onToggleSider} />
      <Layout className="site-layout" style={{ height: "calc(100vh - 64px)" }}> {/* Adjust height by header height (e.g., 64px) */}
        <Sider
          width={180}
          style={{
            background: "var(--primary)",
            height: "100%",
            overflow: 'auto'
          }}
          collapsible={true}
          collapsed={!showSider}
          onCollapse={onToggleSider}
        >
          <div style={{ paddingTop: '20px' }}>
            <Side collapsed={!showSider} />
          </div>
        </Sider>
        <Content
          style={{
            margin: "0",
            height: "100%",
            overflow: "auto",
            background: "transparent",
          }}
        >
          <div
            className="site-layout-background"
            style={{ height: "100%", overflowY: "auto" }}
          >
            <IAPlatformRoutes widgets={widgets} />
          </div>
        </Content>
      </Layout>
    </Layout>
  );
};

export default Frame;
